<template>
  <div>
    <v-container>
      <div class="text-center mt-16">
        <v-icon size="150" color="white"
          >mdi-checkbox-marked-circle-outline</v-icon
        >
        <div style="color: white; font-size: 40px; font-weight: bold">
          SUCCESSFUL
        </div>
        <!-- <div class="mt-6">
          <v-btn
            @click="closeliff"
            color="white"
            outlined
            large
            rounded
            style="font-size: 25px"
            >CLOSE</v-btn
          >
        </div> -->
      </div>
    </v-container>
  </div>
</template>

<script>
export default {
  methods: {
    closeliff() {
      this.$liff.closeWindow();
    },
  },
};
</script>

<style lang="scss" scoped></style>
